var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4345 6.47968C19.0381 6.47968 20.338 5.17972 20.338 3.57614C20.338 1.97256 19.0381 0.672607 17.4345 0.672607C15.831 0.672607 14.531 1.97256 14.531 3.57614C14.531 5.17972 15.831 6.47968 17.4345 6.47968Z",
    fill: "#8055FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4343 13.4462C19.0379 13.4462 20.3378 12.1464 20.3378 10.543C20.3378 8.93967 19.0379 7.63989 17.4343 7.63989C15.8308 7.63989 14.5309 8.93967 14.5309 10.543C14.5309 12.1464 15.8308 13.4462 17.4343 13.4462Z",
    fill: "#7550FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4343 20.6728C19.0379 20.6728 20.3378 19.3728 20.3378 17.7693C20.3378 16.1657 19.0379 14.8657 17.4343 14.8657C15.8308 14.8657 14.5309 16.1657 14.5309 17.7693C14.5309 19.3728 15.8308 20.6728 17.4343 20.6728Z",
    fill: "#6A4AFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2085 13.4462C11.8119 13.4462 13.1116 12.1464 13.1116 10.543C13.1116 8.93967 11.8119 7.63989 10.2085 7.63989C8.6052 7.63989 7.30544 8.93967 7.30544 10.543C7.30544 12.1464 8.6052 13.4462 10.2085 13.4462Z",
    fill: "#6045FD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2085 13.4462C11.8119 13.4462 13.1116 12.1464 13.1116 10.543C13.1116 8.93967 11.8119 7.63989 10.2085 7.63989C8.6052 7.63989 7.30544 8.93967 7.30544 10.543C7.30544 12.1464 8.6052 13.4462 10.2085 13.4462Z",
    stroke: "#A0A3BD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2082 20.6725C11.8116 20.6725 13.1113 19.3726 13.1113 17.769C13.1113 16.1654 11.8116 14.8655 10.2082 14.8655C8.60489 14.8655 7.30514 16.1654 7.30514 17.769C7.30514 19.3726 8.60489 20.6725 10.2082 20.6725Z",
    fill: "#553FFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.24137 20.6728C4.84491 20.6728 6.14484 19.3728 6.14484 17.7693C6.14484 16.1657 4.84491 14.8657 3.24137 14.8657C1.63782 14.8657 0.337891 16.1657 0.337891 17.7693C0.337891 19.3728 1.63782 20.6728 3.24137 20.6728Z",
    fill: "#4A3AFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c9d3f308c71757518393110a862a04d9.svg";
export { ForwardRef as ReactComponent };